import React, { useState } from "react";

const CreateProject = () => {

    const [selected, setSelected] = useState("");

    const services = [
        {
            id: "website",
            title: "Need a Website",
            description:
                "Select an option if you need Landing Page, Website or any Portal",
            icon: "✓",
        },
        {
            id: "branding",
            title: "Social Branding",
            description:
                "Select an option if you need Social Branding, Promotions or increases Leads",
            icon: "📱",
        },
        {
            id: "ads",
            title: "Paid Campaigns",
            description:
                "Select an option if you need Paid Promotions on Social Network or Google",
            icon: "📢",
        },
        {
            id: "maintenance",
            title: "Maintenance",
            description:
                "Select an option if you need maintenance or update your website or page",
            icon: "🛠",
        },
        {
            id: "seo",
            title: "SEO",
            description:
                "Select an option if you need SEO and Organic traffic on Google",
            icon: "📈",
        },
    ];

    const handleNext = () => {
        if (!selected) {
            alert("Please select a service.");
            return;
        }

        console.log(selected);

        // Navigate to next step here
        // navigate('/step-2');
    };

    return (
        <>
          

              
                <div className="content">

                    <main className="page-content p-4">

                        <div className="card shadow-sm mb-4">

                            <div className="card-body">

                                <h2>Create A Project</h2>

                                <p className="text-muted">
                                    Choose a service to create your project.
                                </p>

                                  <div className="row justify-content-center g-4">

                            {services.map((item) => (

                                <div className="col-lg-4 col-md-6" key={item.id}>

                                    <div
                                        className={`service-card ${selected === item.id ? "active" : ""}`}
                                        onClick={() => setSelected(item.id)}
                                    >

                                        <input
                                            type="radio"
                                            hidden
                                            checked={selected === item.id}
                                            onChange={() => setSelected(item.id)}
                                        />

                                        <div className="icon">
                                            {item.icon}
                                        </div>

                                        <h4>{item.title}</h4>

                                        <p>{item.description}</p>

                                    </div>

                                </div>

                            ))}

                        </div>

                        <div className="text-center mt-5">

                            <button
                                className="btn btn-primary px-5 py-2"
                                onClick={handleNext}
                            >
                                Next →
                            </button>

                        </div>

                            </div>

                        </div>

                      

                    </main>

                </div>

          
        </>
    );
};

export default CreateProject;